module.exports = __webpack_public_path__ + "assets/img/startProgress.43812e50.svg";